import logger from '../log';
import { NetworkData, setNetworkData } from './networkDataStorage';
import { isValid } from 'ipaddr.js';

const log = logger.getLogger(__filename);

function getCandidateAddress(
  iceCandidate: RTCIceCandidate
): { addr: string; type: string } {
  // some browsers wont have the ip field (or address in case of chrome). So we parse the string
  const candidateStr = iceCandidate.candidate;
  // candidate-attribute   = "candidate" ":" foundation SP component-id SP
  //                            transport SP
  //                            priority SP
  //                            connection-address SP     ;from RFC 4566
  //                            port         ;port from RFC 4566
  //                            SP cand-type
  //                            [SP rel-addr]
  //                            [SP rel-port]
  //                            *(SP extension-att-name SP
  //                                 extension-att-value)

  //    foundation            = 1*32ice-char
  //    component-id          = 1*5DIGIT
  //    transport             = "UDP" / transport-extension
  //    transport-extension   = token              ; from RFC 3261
  //    priority              = 1*10DIGIT
  //    cand-type             = "typ" SP candidate-types
  //    candidate-types       = "host" / "srflx" / "prflx" / "relay" / token
  //    rel-addr              = "raddr" SP connection-address
  //    rel-port              = "rport" SP port
  //    extension-att-name    = byte-string    ;from RFC 4566
  //    extension-att-value   = byte-string
  //    ice-char              = ALPHA / DIGIT / "+" / "/"
  const colonIdx = candidateStr.indexOf(':');
  const pieces = candidateStr.substring(colonIdx + 1).split(' ');

  const addr = pieces[4];

  const type = pieces[7];
  return { addr, type };
}

export function parseIceCandidates(
  iceCandidates: RTCIceCandidate[]
): NetworkData {
  const parsed = iceCandidates
    .filter(c => !!c.candidate)
    .map(c => getCandidateAddress(c));
  const localCandidate = parsed.filter(p => p.type === 'host')[0];
  const externalCandidate = parsed.filter(p => p.type === 'srflx')[0];
  const data: NetworkData = {};
  if (localCandidate) {
    if (isValid(localCandidate.addr)) {
      data.internalIp = localCandidate.addr;
    } else {
      data.internalMdns = localCandidate.addr;
    }
  }
  if (externalCandidate) {
    data.externalIp = externalCandidate.addr;
  }
  return data;
}

/**
 * @returns type of internal addresses. mdns, ip, or unknown if we have
 * no internalIp or internalMdns
 */
export default function storeNetworkData(networkData: NetworkData): void {
  try {
    setNetworkData(networkData);
  } catch (e) {
    log.warn('Failed to store Network Data', e);
  }
}
